import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import Tooltip from 'rc-tooltip';
import moment from "moment";
import { isDefined, cloneArray, sortReactTable, formatDate, arrayIsNotEmpty, getOnlyUnique } from '../../../../utils';
import { dateFormat, columnsAccessors } from '../../../../constants';
import ZSearch from '../../../../components/Common/ZSearch';
import { ChannelTypeDictionary, ChannelType } from '../../../../generated'
import CallChannelIcon from '../../../../icons/CallChannelIcon';
import EmailChannelIcon from '../../../../icons/EmailChannelIcon';
import ChatChannelIcon from '../../../../icons/ChatChannelIcon';
import MatchingAnswersIcon from '../../../../icons/MatchingAnswersIcon';
import NotMatchingAnswersIcon from '../../../../icons/NotMatchingAnswersIcon';
import MatchingAnswersIconNotActive from '../../../../icons/MatchingAnswersIconNotActive';
import NotMatchingAnswersIconNotActive from '../../../../icons/NotMatchingAnswersIconNotActive';
import FilterIcon from '../../../../icons/FilterIcon';
import FilterIconBack from '../../../../icons/FilterIconBack';
import CloseFilterIcon from '../../../../icons/CloseFilterIcon';
import Close from "@material-ui/icons/Close";

class AgentInteractions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fromDate: moment().subtract(7, 'd').format(dateFormat),
            toDate: moment().format(dateFormat),
            showSelectReasonsForContactPopup: false,
            showFiltersHeader: false,
            searchChannelOrInteractionIdQuery: undefined,
            searchRfcQuery: undefined,
            showAsatMatchesActive: true,
            showAsatNotMatchesActive: true,
            showResMatchesActive: true,
            showResNotMatchesActive: true,
            showCsatMatchesActive: true,
            showCsatNotMatchesActive: true,
            showNpsMatchesActive: true,
            showNpsNotMatchesActive: true,
            selectedReasonForContact: undefined,
        };

        this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.onSearchByChannelOrInteractionId = this.onSearchByChannelOrInteractionId.bind(this);
        this.onSearchByRfc = this.onSearchByRfc.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);
        this.changeMatches = this.changeMatches.bind(this);
        this.changeNotMatches = this.changeNotMatches.bind(this);
    }

    changeMatches(questionCode) {
        switch (questionCode) {
            case 'ASAT':
                this.setState((prevState) => ({
                    showAsatMatchesActive: !prevState.showAsatMatchesActive
                }));
                break;
            case 'RES':
                this.setState((prevState) => ({
                    showResMatchesActive: !prevState.showResMatchesActive
                }));
                break;
            case 'CSAT':
                this.setState((prevState) => ({
                    showCsatMatchesActive: !prevState.showCsatMatchesActive
                }));
                break;
            case 'tNPS':
                this.setState((prevState) => ({
                    showNpsMatchesActive: !prevState.showNpsMatchesActive
                }));
                break;
            default:
        }
    }

    changeNotMatches(questionCode) {
        switch (questionCode) {
            case 'ASAT':
                this.setState((prevState) => ({
                    showAsatNotMatchesActive: !prevState.showAsatNotMatchesActive
                }));
                break;
            case 'RES':
                this.setState((prevState) => ({
                    showResNotMatchesActive: !prevState.showResNotMatchesActive
                }));
                break;
            case 'CSAT':
                this.setState((prevState) => ({
                    showCsatNotMatchesActive: !prevState.showCsatNotMatchesActive
                }));
                break;
            default:
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    showFiltersHeader() {
        this.setState({ showFiltersHeader: true });
    }

    hideFiltersHeader() {
        this.setState({
            showFiltersHeader: false,
            searchChannelOrInteractionIdQuery: undefined,
            searchRfcQuery: undefined,
            showAsatMatchesActive: true,
            showAsatNotMatchesActive: true,
            showResMatchesActive: true,
            showResNotMatchesActive: true,
            showCsatMatchesActive: true,
            showCsatNotMatchesActive: true,
            showNpsMatchesActive: true,
            showNpsNotMatchesActive: true,
        });
    }

    //RFC show hide
    //showSelectReasonsForContactPopup() {
    //    this.setState({ showSelectReasonsForContactPopup: true });
    //}

    //hideSelectReasonsForContactPopup(selectedReasonForContact) {
    //    this.setState({ showSelectReasonsForContactPopup: false });

    //    if (((!selectedReasonForContact || selectedReasonForContact.length === 0) &&
    //        (!this.state.selectedReasonForContact || this.state.selectedReasonForContact.length === 0)) ||
    //        (selectedReasonForContact && this.state.selectedReasonForContact &&
    //            selectedReasonForContact.id === this.state.selectedReasonForContact.id)) {
    //        return;
    //    }

    //    if (selectedReasonForContact && selectedReasonForContact.length === 0) {
    //        this.setState({ selectedReasonForContact: undefined });
    //    }
    //    else {
    //        this.setState({ selectedReasonForContact: selectedReasonForContact[0] });
    //    }
    //}

    //hideSelectReasonsForContactFiltersHeader() {
    //    this.setState({ selectedReasonForContact: undefined });
    //}
    onSearchByChannelOrInteractionId({ target }) {
        this.setState({ searchChannelOrInteractionIdQuery: target.value });
    }

    onSearchByRfc({ target }) {
        this.setState({ searchRfcQuery: target.value });
    }

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
            } = this.props;
        let interactionHeader = 'Interaction';
        let rfcHeader = 'RFC';

        if (this.state.showFiltersHeader) {
            interactionHeader = (<ZSearch placeHolder="Interaction Id or Channel" searchValue={this.state.searchChannelOrInteractionIdQuery} onChange={this.onSearchByChannelOrInteractionId} />);
            rfcHeader = (<div style={{ maxWidth: '207px' }}><ZSearch placeHolder="Reason For Contact" searchValue={this.state.searchRfcQuery} onChange={this.onSearchByRfc} /></div>);
        }
        const interactionColumn =
        {
            Header: interactionHeader,
            accessor: 'interactionExternalNumberToShow'
        };

        const columns = [interactionColumn];

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                if (!this.state.showFiltersHeader) {
                    columns.push(
                        {
                            Header: sq.shortName,
                            accessor: sq.questionCode
                        }
                    );
                }
                else {
                    let matchingIcon;
                    let notMatchingIcon;

                    switch (sq.questionCode) {
                        case 'ASAT':
                            matchingIcon = this.state.showAsatMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showAsatNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'RES':
                            matchingIcon = this.state.showResMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showResNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'CSAT':
                            matchingIcon = this.state.showCsatMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showCsatNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'tNPS':
                            matchingIcon = this.state.showNpsMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showNpsNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        default:
                    }

                    const matches = <div style={{ height: '33px', margin: '4px 0 0 6px' }} onClick={() => this.changeMatches(sq.questionCode)} >
                        {matchingIcon}
                    </div>;
                    const notMatches = <div style={{ height: '33px', margin: '4px 0 0 2px' }} onClick={() => this.changeNotMatches(sq.questionCode)} >
                        {notMatchingIcon}</div>;

                    columns.push(
                        {
                            Header: <div style={{ display: 'flex', justifyContent: 'center', height: '38px', marginTop: '4px' }}>
                                {sq.shortName} {matches}{notMatches}
                            </div>,
                            accessor: sq.questionCode
                        }
                    );
                }
            });
        }

        columns.push(
            {
                Header: 'Date-Time',
                accessor: columnsAccessors.date
            });
        columns.push(
            {
                Header: rfcHeader,
                accessor: columnsAccessors.reasonForContact
            });


        return columns;
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                agentInteractions,
                onClose
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();

        const isFetching = agentInteractions ? false : true;
        result.data = [];
        const agentInteractionsCopy = cloneArray(agentInteractions);
        if (arrayIsNotEmpty(agentInteractionsCopy)) {
            const ticketIds = agentInteractionsCopy.map(p => p.id).filter(getOnlyUnique);
            ticketIds.map(tId => {
                const ticketData = agentInteractionsCopy.filter(ai => ai.id === tId);
                if (arrayIsNotEmpty(ticketData)) {
                    let tdRow = {};
                    tdRow.interactionExternalNumber = ticketData[0].interactionExternalNumber
                    tdRow.reasonForContact = ticketData[0].reasonForContact;
                    tdRow.channelType = ticketData[0].channelType;
                    tdRow.date = formatDate(ticketData[0].externalOpenDate);

                    calibratedOnSurveyQuestions.map(cq => {
                        const questionDataForTicket = ticketData.find(td => td.questionCode === cq.questionCode);
                        if (isDefined(questionDataForTicket)) {
                            tdRow[`${cq.questionCode}ResponsesMatch`] = questionDataForTicket.responsesMatch;
                            tdRow[`${cq.questionCode}AgentPrediction`] = questionDataForTicket.agentResponse;
                            tdRow[`${cq.questionCode}CustomerMappedResponse`] = questionDataForTicket.customerResponse;
                        }
                    });
                    result.data.push(tdRow);
                }
            });
        }

        if (isDefined(this.state.searchChannelOrInteractionIdQuery) && this.state.searchChannelOrInteractionIdQuery != '') {
            let isnum = /^\d+$/.test(this.state.searchChannelOrInteractionIdQuery);
            if (isnum) {
                result.data = result.data.filter(a => a.interactionExternalNumber.toLowerCase().includes(this.state.searchChannelOrInteractionIdQuery.toLowerCase()));
            }
            else {
                result.data = result.data.filter(a => ChannelTypeDictionary[a.channelType].toLowerCase().includes(this.state.searchChannelOrInteractionIdQuery.toLowerCase()));
            }
        }

        if (isDefined(this.state.searchRfcQuery) && this.state.searchRfcQuery != '') {
            result.data = result.data.filter(a => a.reasonForContact.toLowerCase().includes(this.state.searchRfcQuery.toLowerCase()));
        }

        //Filter by answer match/not match for each question
        //Asat
        if (isDefined(this.state.showAsatMatchesActive)) {
            if (this.state.showAsatMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.representativeSatisfactionAgentPrediction !=
                    a.representativeSatisfactionCustomerMappedResponse);
            }
        }
        if (isDefined(this.state.showAsatNotMatchesActive)) {
            if (this.state.showAsatNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.representativeSatisfactionAgentPrediction ===
                    a.representativeSatisfactionCustomerMappedResponse);
            }
        }
        //Res
        if (isDefined(this.state.showResMatchesActive)) {
            if (this.state.showResMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.resolutionAgentPrediction !==
                    a.resolutionCustomerMappedResponse);
            }
        }
        if (isDefined(this.state.showResNotMatchesActive)) {
            if (this.state.showResNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.resolutionAgentPrediction ===
                    a.resolutionCustomerMappedResponse);
            }
        }

        //Csat
        if (isDefined(this.state.showCsatMatchesActive)) {
            if (this.state.showCsatMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.customerSatisfactionAgentPrediction !==
                    a.customerSatisfactionCustomerMappedResponse);
            }
        }
        if (isDefined(this.state.showCsatNotMatchesActive)) {
            if (this.state.showCsatNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.customerSatisfactionAgentPrediction ===
                    a.customerSatisfactionCustomerMappedResponse);
            }
        }

        //NPS
        if (isDefined(this.state.showNpsMatchesActive)) {
            if (this.state.showNpsMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.NetPromoterScoreAgentPredictionPerformanceResponseTypeId !==
                    a.NetPromoterScoreCustomerResponsePerformanceResponseTypeId);
            }
        }
        if (isDefined(this.state.showNpsNotMatchesActive)) {
            if (this.state.showCsatNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.NetPromoterScoreAgentPredictionPerformanceResponseTypeId ===
                    a.NetPromoterScoreCustomerResponsePerformanceResponseTypeId);
            }
        }

        //if (isDefined(this.state.selectedReasonForContact)) {
        //    result.data = result.data.filter(a => a.reasonForContact === this.state.selectedReasonForContact.value);
        //}

        ////////////////////


        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                    calibratedOnSurveyQuestions.forEach(cq => {

                        const agentPrediction = row[`${cq.questionCode}AgentPrediction`];
                        const customerMappedResponse = row[`${cq.questionCode}CustomerMappedResponse`];

                        const responseMatched = row[`${cq.questionCode}ResponsesMatch`];
                        let iconNode = <div>-</div>;

                        if (agentPrediction && customerMappedResponse) {
                            let icon;
                            let matchingText;
                            let buttonClass = "v3-button cursor-auto match-title "
                            if (responseMatched) {
                                icon = <MatchingAnswersIcon />
                                matchingText = 'match';
                                buttonClass += "color-green-gradient";
                            }
                            else {
                                icon = <NotMatchingAnswersIcon />
                                matchingText = 'mismatch';
                                buttonClass += "color-red-gradient";
                            }


                            const text = <div style={{ backgroundColor: 'white', margin: '-6px -7px', padding: '5px' }}>
                                <div className="flex justify-content-center">
                                    <div className={buttonClass} >
                                        {matchingText}
                                    </div>
                                </div>
                                <div className="flex flex-space-between" style={{ padding: '0 20px' }}>
                                    <div style={{ marginRight: '7px' }}>
                                        <div className="match-answer-title">Customer Said</div>
                                        <div className="match-answer-title">Agent Predicted</div>
                                    </div>
                                    <div>
                                        <div className="match-answer-label text-primary-color">{customerMappedResponse}</div>
                                        <div className="match-answer-label text-primary-color" >{agentPrediction}</div>
                                    </div>
                                </div>
                            </div>

                            iconNode = <Tooltip placement="bottom" overlay={text}>
                                <div className="flex-container-center">
                                    {icon}
                                </div>
                            </Tooltip>;
                        }
                        else if (isDefined(customerMappedResponse)) {
                            iconNode = <div><span className="agent-or-customer-response-indicator">C</span>{customerMappedResponse}</div>
                        }
                        else if (isDefined(agentPrediction)) {
                            iconNode = <div><span className="agent-or-customer-response-indicator">A</span>{agentPrediction}</div>
                        }
                        row[cq.questionCode] = iconNode;
                    });
                }
                if (isDefined(row.interactionExternalNumber)) {
                    let channelIcon = <CallChannelIcon />
                    if (row.channelType == 'Chat') {
                        channelIcon = <ChatChannelIcon />
                    }
                    else if (row.channelType == 'Email' || row.channelType == 'Form') {
                        channelIcon = <EmailChannelIcon />
                    }
                    row.interactionExternalNumberToShow =
                        (<div className="flex-container-center">
                            <div className="flex-container-center">
                                {channelIcon}
                            </div>
                            <div style={{ margin: "0 0 0 10px" }}>{row.interactionExternalNumber}</div>
                        </div>)
                }
            });
        }


        const defaultPageSize = 10; // result.data.length >= 10 ? 10 : 5;
        const interactionssResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={defaultPageSize}
            loading={isFetching}
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            //this.onSelectInteraction(rowInfo.original.id)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return (
            <div className="modal displayBlock">
                <div className="modal-content" style={{ margin: '40px auto' }}>
                    <div className="flex flex-flex-end"><Close className="cursor-pointer" onClick={() => onClose()} /></div>
                    <div className="teams-table-for-manager filters-wrapper-interaction">
                        <div className="teams-table-for-manager filter-area-title-wrapper" style={{ margin: '10px' }} >
                            <label className="teams-table-for-manager all-teams-title">Ticket list</label>
                        </div>
                        {/*
                        <div className="teams-table-for-manager teams-filter-names-wrapper">
                            {dateFiltersNode}
                        </div>
                        */ }
                    </div>
                    <div style={{ position: 'relative' }}>
                        {!this.state.showFiltersHeader &&
                            <div onClick={this.showFiltersHeader} style={{
                                position: 'absolute',
                                zIndex: 2,
                                right: '0',
                                cursor: 'pointer'
                            }}>
                                <FilterIconBack />
                            </div>}
                        {!this.state.showFiltersHeader &&
                            <div onClick={this.showFiltersHeader} style={{
                                position: 'absolute',
                                zIndex: 3,
                                right: '0',
                                cursor: 'pointer'
                            }}>
                                <FilterIcon />
                            </div>}

                        {this.state.showFiltersHeader &&
                            <div onClick={this.hideFiltersHeader} style={{
                                position: 'absolute',
                                zIndex: 2,
                                right: '9px',
                                top: '9px',
                                cursor: 'pointer'
                            }}>
                                <CloseFilterIcon />
                            </div>}
                        {interactionssResultTable}
                    </div>
                </div>
            </div>);
    }
};

const select = state => ({});

export default connect(select)(AgentInteractions);

